import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { useAuthStore } from './stores/authStore';
import { ToastContainer } from './components/ui/Toast';
import { apiService } from './services/api';
import LoginPage from './pages/LoginPage';
import BriefPage from './features/brief/BriefPage';

// Legacy full-feature console — lazy-loaded so its ~8.7k-line bundle is a
// separate chunk fetched only when an operator opens /classic, keeping the
// main (Бриф) bundle lean.
const PromotionPublisherPage = lazy(() => import('./pages/PromotionPublisherPage'));

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const token = useAuthStore((state) => state.token);
  if (!isAuthenticated || !token) return <Navigate to="/login" replace />;
  return children;
}

function PromotionShell() {
  const navigate = useNavigate();

  const logout = async () => {
    await apiService.logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="h-screen overflow-hidden bg-white">
      <BriefPage onLogout={logout} />
    </div>
  );
}

function ClassicShell() {
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);

  const logout = async () => {
    await apiService.logout();
    navigate('/login', { replace: true });
  };

  return (
    <Suspense
      fallback={
        <div className="flex h-screen items-center justify-center text-sm text-zinc-500">
          Загрузка классической консоли…
        </div>
      }
    >
      <PromotionPublisherPage user={user} onLogout={logout} />
    </Suspense>
  );
}

export default function App() {
  return (
    <>
      <ToastContainer />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <PromotionShell />
              </ProtectedRoute>
            }
          />
          <Route
            path="/classic"
            element={
              <ProtectedRoute>
                <ClassicShell />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}
